// extracted by mini-css-extract-plugin
module.exports = {"link":"ExternalLink_link__2R01U","linkIcon":"ExternalLink_linkIcon__1S5WM"};